import * as Sentry from '@sentry/react';

export const signOutOfZendesk = () => {
  try {
    window.zE?.('messenger', 'logoutUser');
  } catch (error) {
    Sentry.captureException(error);
  }
};
